import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, InputProps, TextField } from '@mui/material';

type CallbackFunction = (v: string) => void;
type SearchFieldProps = {
  searchTerm?: string;
  setSearchTerm: CallbackFunction;
  placeholder?: string;
  style?: object;
};

function SearchField(props: SearchFieldProps) {
  const { searchTerm, setSearchTerm, placeholder, style } = props;
  return (
    <TextField
      size="small"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{ minWidth: '360px', height: '32px', fontSize: '13px', ...style }}
      autoFocus
      placeholder={placeholder}
      InputProps={
        {
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
          style: {
            paddingRight: '10px',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingLeft: '10px',
            fontSize: '13px',
          },
        } as InputProps
      }
    />
  );
}

export default SearchField;
